import "/assets/styles/sections/home/features.scss";

// Partials
import Icon from '@wearetla/tla-essentials-tools/partials/icon';

const Features = () => {
	return (
		<main
			id="features"
			className="section home-features">
			<div className="features-wrap wrapper">
				<h1 className="features-pretitle">Our Core Value</h1>
				<h2 className="features-title">Built for the Modern Event Organizer</h2>

				<ul className="features-list">
					<li className="list-item">
						<Icon className="item-icon" name="ticket" />
						<strong className="item-title">
							Smart Ticketing
						</strong>

						<div className="item-description">
							Create tiered pricing, manage guest lists, and issue QR codes instantly. Our system handles the complexity so you can focus on the experience.
						</div>
					</li>
					<li className="list-item">
						<Icon className="item-icon" name="analytics" />
						<strong className="item-title">
							Real Time Analytics
						</strong>

						<div className="item-description">
							Track sales, attendance, and revenue in real-time. Make data-driven decisions on the fly with our comprehensive dashboard.
						</div>
					</li>
					<li className="list-item">
						<Icon className="item-icon" name="payment" />
						<strong className="item-title">
							Seamless Payments
						</strong>

						<div className="item-description">
							Accept payments globally with built-in fraud protection. Payouts are automated and transparent, keeping your cash flow healthy.
						</div>
					</li>
				</ul>
			</div>
		</main>
	);
};

export default Features;
